import { BaseExpressionRegister } from "./_BaseRegister";
export class ExpressionRegister extends BaseExpressionRegister {
  getMethod(name) {
    return super.getMethod(name);
  }
}
